<template>
  <section
    class="layout-pt-lg layout-pb-lg"
    v-if="variants.v1 === variant && sidebarComponents.length === 0"
    :style="`background-color: var(--c-${vars.backgroundColor}); color: ${vars.textColor ? `var(--c-${vars.textColor})` : 'var(--c-text-primary)'}`"
  >
    <div
      class="container tw-flex tw-w-full tw-max-w-none tw-flex-col tw-items-center tw-gap-6 lg:tw-max-w-none lg:tw-items-center"
    >
      <div class="lg:tw-flex-row lg:tw-items-center lg:tw-justify-between">
        <h2 :style="`color: var(--c-${vars.titleColor});`">
          {{ vars.titleText }}
        </h2>

        <div class="tw-mb-12 tw-mt-6 tw-hidden tw-justify-center lg:tw-flex">
          <nuxt-link
            v-for="(button, index) in buttons"
            :key="`button-desktop-${index}`"
            :class="['tw-w-full lg:tw-w-auto', `n-${button.button_type}`, 'tw-text-center tw-uppercase']"
            :to="button.button_link"
          >
            {{ button.button_label }}
          </nuxt-link>
        </div>
      </div>

      <div class="tw-relative tw-flex tw-flex-col tw-items-center lg:tw-w-[90%] lg:tw-flex-row">
        <!-- Left arrow (desktop only) -->
        <div
          @click="swiper.slidePrev()"
          v-if="canPaginateBack"
          class="d-none d-lg-block arrow-button tw-absolute tw-left-4 tw-top-1/2 tw-z-10 tw--translate-y-1/2 tw-cursor-pointer"
        >
          <svg width="61" height="27" viewBox="0 0 61 27" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M10.4697 14.0303C10.1768 13.7374 10.1768 13.2626 10.4697 12.9697L15.2426 8.1967C15.5355 7.90381 16.0104 7.90381 16.3033 8.1967C16.5962 8.48959 16.5962 8.96447 16.3033 9.25736L12.0607 13.5L16.3033 17.7426C16.5962 18.0355 16.5962 18.5104 16.3033 18.8033C16.0104 19.0962 15.5355 19.0962 15.2426 18.8033L10.4697 14.0303ZM61 14.25H11V12.75H61V14.25Z"
              fill="#BFA87E"
            />
            <circle
              cx="13.5"
              cy="13.5"
              r="13"
              transform="matrix(-1 0 0 1 27 0)"
              stroke="#BFA87E"
              stroke-opacity="0.5"
            />
          </svg>
        </div>

        <div class="content-container tw-w-full tw-px-4 lg:tw-px-14">
          <div class="swiper-wrapper">
            <Swiper
              :key="'property-swiper-' + properties.length"
              :modules="[SwiperPagination]"
              :pagination="false"
              :slides-per-view="1"
              :space-between="10"
              effect="fade"
              :clickable="true"
              :watch-overflow="true"
              @slideChange="onSlideChange"
              @swiper="onSwiper"
              :breakpoints="{
                320: { slidesPerView: 1, spaceBetween: 10 },
                1024: { slidesPerView: 2, spaceBetween: 24 },
                1280: { slidesPerView: 2, spaceBetween: 24 },
              }"
              class="tw-w-full md:tw-w-[90%]"
            >
              <SwiperSlide
                v-for="(property, index) in properties"
                :key="`latestproperties-property-${index}`"
                class="tw-w-full"
              >
                <theme8-properties-property-list-item
                  :property="property"
                  :is-match-information-hidden="true"
                  version="v1"
                  :index="index"
                  :pre-market-blur-text="vars.preMarketBlurredImageTextHtml"
                />
              </SwiperSlide>
            </Swiper>
          </div>
        </div>

        <!-- Right arrow (desktop only) -->
        <div
          @click="swiper.slideNext()"
          v-if="canPaginateNext"
          class="d-none d-lg-block arrow-button tw-absolute tw-right-4 tw-top-1/2 tw-z-10 tw--translate-y-1/2 tw-cursor-pointer"
        >
          <svg width="61" height="27" viewBox="0 0 61 27" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M50.5303 14.0303C50.8232 13.7374 50.8232 13.2626 50.5303 12.9697L45.7574 8.1967C45.4645 7.90381 44.9896 7.90381 44.6967 8.1967C44.4038 8.48959 44.4038 8.96447 44.6967 9.25736L48.9393 13.5L44.6967 17.7426C44.4038 18.0355 44.4038 18.5104 44.6967 18.8033C44.9896 19.0962 45.4645 19.0962 45.7574 18.8033L50.5303 14.0303ZM0 14.25H50V12.75H0V14.25Z"
              fill="#BFA87E"
            />
            <circle cx="47.5" cy="13.5" r="13" stroke="#BFA87E" stroke-opacity="0.5" />
          </svg>
        </div>
      </div>

      <!-- Mobil pagination okları -->
      <div class="tw-mt-2 tw-flex tw-items-center tw-justify-center tw-gap-4 md:tw-hidden">
        <div v-if="canPaginateBack" @click="swiper.slidePrev()" class="arrow-button tw-cursor-pointer">
          <svg width="61" height="27" viewBox="0 0 61 27" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M10.4697 14.0303C10.1768 13.7374 10.1768 13.2626 10.4697 12.9697L15.2426 8.1967C15.5355 7.90381 16.0104 7.90381 16.3033 8.1967C16.5962 8.48959 16.5962 8.96447 16.3033 9.25736L12.0607 13.5L16.3033 17.7426C16.5962 18.0355 16.5962 18.5104 16.3033 18.8033C16.0104 19.0962 15.5355 19.0962 15.2426 18.8033L10.4697 14.0303ZM61 14.25H11V12.75H61V14.25Z"
              fill="#BFA87E"
            />
            <circle
              cx="13.5"
              cy="13.5"
              r="13"
              transform="matrix(-1 0 0 1 27 0)"
              stroke="#BFA87E"
              stroke-opacity="0.5"
            />
          </svg>
        </div>
        <div v-if="canPaginateNext" @click="swiper.slideNext()" class="arrow-button tw-cursor-pointer">
          <svg width="61" height="27" viewBox="0 0 61 27" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M50.5303 14.0303C50.8232 13.7374 50.8232 13.2626 50.5303 12.9697L45.7574 8.1967C45.4645 7.90381 44.9896 7.90381 44.6967 8.1967C44.4038 8.48959 44.4038 8.96447 44.6967 9.25736L48.9393 13.5L44.6967 17.7426C44.4038 18.0355 44.4038 18.5104 44.6967 18.8033C44.9896 19.0962 45.4645 19.0962 45.7574 18.8033L50.5303 14.0303ZM0 14.25H50V12.75H0V14.25Z"
              fill="#BFA87E"
            />
            <circle cx="47.5" cy="13.5" r="13" stroke="#BFA87E" stroke-opacity="0.5" />
          </svg>
        </div>
      </div>

      <div class="tw-mt-4 tw-block lg:tw-mt-10 lg:tw-hidden">
        <nuxt-link
          v-for="(button, index) in buttons"
          :key="`button-mobile-${index}`"
          :class="['tw-inline-flex tw-items-center', `n-${button.button_type}`, 'tw-text-center tw-uppercase']"
          :to="button.button_link"
        >
          {{ button.button_label }}
        </nuxt-link>
      </div>
    </div>
  </section>

  <div v-else-if="sidebarComponents.length > 0" :style="`background-color: var(--c-${vars.backgroundColor})`">
    <div
      class="tw-grid tw-w-full tw-grid-cols-12 tw-grid-rows-1 tw-items-center tw-p-7"
      :style="`color: var(--c-${vars.textColor})`"
      style="border-radius: var(--rounded)"
    >
      <H3 class="tw-col-span-12 tw-mb-4">LATEST PROPERTIES</H3>
      <div class="swiper-wrapper tw-col-span-12">
        <Swiper
          :key="'property-swiper-' + properties.length"
          :modules="[SwiperPagination]"
          :pagination="false"
          :slides-per-view="1"
          :space-between="10"
          effect="fade"
          :clickable="true"
          :watch-overflow="true"
          @slideChange="onSlideChange"
          @swiper="onSwiper"
          :breakpoints="{
            320: { slidesPerView: 1, spaceBetween: 10 },
          }"
          class="tw-w-full"
        >
          <SwiperSlide
            v-for="(property, index) in properties"
            :key="`latestproperties-property-${index}`"
            class="tw-w-full"
          >
            <theme8-properties-property-list-item
              :property="property"
              :is-match-information-hidden="true"
              version="v1"
              :index="index"
              :pre-market-blur-text="vars.preMarketBlurredImageTextHtml"
            />
          </SwiperSlide>
        </Swiper>
      </div>
      <div class="tw-col-span-12 tw-mt-6 tw-flex tw-items-center tw-justify-center tw-gap-4">
        <div v-if="canPaginateBack" @click="swiper.slidePrev()" class="arrow-button tw-cursor-pointer">
          <svg width="61" height="27" viewBox="0 0 61 27" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M10.4697 14.0303C10.1768 13.7374 10.1768 13.2626 10.4697 12.9697L15.2426 8.1967C15.5355 7.90381 16.0104 7.90381 16.3033 8.1967C16.5962 8.48959 16.5962 8.96447 16.3033 9.25736L12.0607 13.5L16.3033 17.7426C16.5962 18.0355 16.5962 18.5104 16.3033 18.8033C16.0104 19.0962 15.5355 19.0962 15.2426 18.8033L10.4697 14.0303ZM61 14.25H11V12.75H61V14.25Z"
              fill="#BFA87E"
            />
            <circle
              cx="13.5"
              cy="13.5"
              r="13"
              transform="matrix(-1 0 0 1 27 0)"
              stroke="#BFA87E"
              stroke-opacity="0.5"
            />
          </svg>
        </div>
        <div v-if="canPaginateNext" @click="swiper.slideNext()" class="arrow-button tw-cursor-pointer">
          <svg width="61" height="27" viewBox="0 0 61 27" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M50.5303 14.0303C50.8232 13.7374 50.8232 13.2626 50.5303 12.9697L45.7574 8.1967C45.4645 7.90381 44.9896 7.90381 44.6967 8.1967C44.4038 8.48959 44.4038 8.96447 44.6967 9.25736L48.9393 13.5L44.6967 17.7426C44.4038 18.0355 44.4038 18.5104 44.6967 18.8033C44.9896 19.0962 45.4645 19.0962 45.7574 18.8033L50.5303 14.0303ZM0 14.25H50V12.75H0V14.25Z"
              fill="#BFA87E"
            />
            <circle cx="47.5" cy="13.5" r="13" stroke="#BFA87E" stroke-opacity="0.5" />
          </svg>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';
import { PropertiesMixin } from '~/units/properties/mixins/properties.mixin';
import { mapState } from 'pinia';
import { useWebsiteStore } from '~/units/website/store';

export default defineNuxtComponent({
  name: 'Theme8LatestProperties',

  mixins: [ComponentMixin, PropertiesMixin],

  data() {
    return {
      swiper: null,
      canPaginateBack: true,
      canPaginateNext: true,
      variants: {
        v1: 'v1',
        v2: 'v2',
      },
    };
  },

  async setup(props) {
    await fetchPropertiesManager(props.component, null);
  },

  mounted() {
    this.onSlideChange();
  },

  methods: {
    onSwiper(swiper: object) {
      this.swiper = swiper;
    },

    onSlideChange() {
      if (!this.swiper) return;
      const isAtStart = this.swiper.isBeginning;
      const isAtEnd = this.swiper.isEnd;
      if (isAtStart) this.canPaginateBack = false;
      else this.canPaginateBack = true;
      if (isAtEnd) this.canPaginateNext = false;
      else this.canPaginateNext = true;
    },
  },

  computed: {
    ...mapState(useWebsiteStore, ['sidebarComponents']),
    buttons() {
      return this.groupedVariables.buttons;
    },
  },
});
</script>

<style scoped>
.arrow-button svg circle {
  transition: stroke-opacity 0.3s ease;
}
.arrow-button:hover svg circle {
  stroke-opacity: 1;
}
</style>
